import { h, Component } from 'preact'
import BookmarkItem from './BookmarkItem'

class BookmarkList extends Component {
  renderBookmark = item => {
    return <BookmarkItem key={item.id} bookmark={item} {...this.props} />
  }

  render({ bookmarks}) {
    return (
      <div>
        {bookmarks.map(this.renderBookmark)}
      </div>
    )
  }
}

export default BookmarkList



// WEBPACK FOOTER //
// ./components/BookmarkList.js